import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoggedIn: false,
  token: "",
  isLoading: false,
  user: null,
  user_id: null,
  email: "",
  error: false,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateIsLoading(state, action) {
      state.error = action.payload.error;
      state.isLoading = action.payload.isLoading;
    },
    logIn(state, action) {
      state.isLoggedIn = action.payload.isLoggedIn;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.user_id = action.payload.user_id;
      state.email = action.payload.email;
    },
    signOut(state, action) {
      state.isLoggedIn = false;
      state.token = "";
      state.user_id = null;
    },
    updateRegisterEmail(state, action) {
      state.email = action.payload.email;
    },
  },
});

// Reducer
export default slice.reducer;

export function NewPassword(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    await axios
      .post(
        "/auth/reset-password",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        dispatch(
          slice.actions.logIn({
            isLoggedIn: true,
            token: response.data.token,
          })
        );
        toast.success(response.data.message);
        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: false })
        );
      })
      .catch(function (error) {
        toast.error(error.message);
        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: true })
        );
      });
  };
}

export function ForgotPassword(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    await axios
      .post(
        "/auth/forgot-password",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        toast.success(response.data.message);
        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: false })
        );
      })
      .catch(function (error) {
        toast.error(error.message);
        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: true })
        );
      });
  };
}

export function LoginUser(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    try {
      const response = await axios.post("/auth/login", formValues, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      const { token, user, user_id, message } = response.data;

      dispatch(
        slice.actions.logIn({
          isLoggedIn: true,
          token,
          user,
          user_id,
          email: formValues.email,
        })
      );

      window.localStorage.setItem("user_id", user_id);
      window.localStorage.setItem("token", token);

      toast.success(message);

    } catch (error) {
      toast.error(error.message || "Login failed.");
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: true }));
    } finally {
      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: false }));
    }
  };
}

export function LogoutUser() {
  return async (dispatch, getState) => {
    window.localStorage.removeItem("user_id");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("theme");
    window.location.reload();
    dispatch(slice.actions.signOut());
  };
}

export function RegisterUser(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    try {
      const response = await axios.post("/auth/register", formValues, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      dispatch(slice.actions.updateRegisterEmail({ email: formValues.email }));
      toast.success(response.data.message);

      dispatch(slice.actions.updateIsLoading({ isLoading: false, error: false }));

      // Redirect immediately after successful registration
      if(!getState().auth.error){
        window.location.href = "/auth/verify";
      }

    } catch (error) {
      toast.error(error.message || "Registration failed.");
      dispatch(slice.actions.updateIsLoading({ error: true, isLoading: false }));
    }
  };
}

export function VerifyEmail(formValues) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.updateIsLoading({ isLoading: true, error: false }));

    await axios
      .post(
        "/auth/verify",
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      )
      .then(function (response) {
        dispatch(slice.actions.updateRegisterEmail({ email: "" }));
        window.localStorage.setItem("user_id", response.data.user_id);
        window.localStorage.setItem("token", response.data.token);

        toast.success(response.data.message);
        dispatch(
          slice.actions.logIn({
            isLoggedIn: true,
            user: response.data.user,
            token: response.data.token,
          })
        );

        dispatch(
          slice.actions.updateIsLoading({ isLoading: false, error: false })
        );
      })
      .catch(function (error) {
        toast.error(error.message);
        dispatch(
          slice.actions.updateIsLoading({ error: true, isLoading: false })
        );
      });
  };
}
